var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlignVer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "35px",
    height: "26px",
    viewBox: "-0.5 -0.5 35 26",
    content: "<mxfile host=\"app.diagrams.net\" modified=\"2021-12-24T07:09:51.045Z\" agent=\"5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/96.0.4664.110 Safari/537.36\" version=\"16.0.3\" etag=\"1zIj9f2AiQXFmz7N6xCk\" type=\"google\"><diagram id=\"qDTrG4-CGHmhaMnGWPMC\">7VZNc5swFPw1HM0AghiOsZ02l850xoeeFfQCmgjEyHKx++srWRKCQBImk94qHyzte08fuyvZAdo3l+8Cd/UPToAFSUQuAToESZIld6n60sjVIHGcbw1SCUos5oEj/QMWjCx6pgROk0TJOZO0m4Ilb1so5QTDQvB+mvbM2XTVDlcwA44lZnP0FyWyNmieRR5/BFrVbuU4spEGu2QLnGpMeD+C0EOA9oJzaXrNZQ9Ms+d4MXXf3ogOGxPQyjUFiSn4jdnZns3uS17dYSvBz51NAyHhskQxfnLp0XwL8XAwZQngDUhxVSl2ok1cZJkpcn7I0iJEFus9wQiFcRb5VpiMekR1YquwVbgalvMkqI7lYZkT9DEn0JJ77SM1anmrwF0tGzXfIVZdxVdLQE8WqdEzb6V1cG6He864uE2E0oP+KPwkBX+BUeTu1lTELA5kZklPcPIuwds0zLPCtwnXm3gbzpl2Th5T67Alau3aPzlVWxoWRtFU1iR8pc6Jn0UJtmrsUjfRm5USiwrkrPIm7cDAKrXTj9X2gmp5+5pKOHa41NFevXBT9Rl+ArbD5Ut1K3OKWpt8yg2uljK2lFwJTCj4iWw6ZrRq1bBUIVD4Tt9eqh6xextoKCH6iMqwEkvKNVZEg+MWLvt6z23iifRLHksWPBa/47G11zf7L+g/EDR/9fSu0Df7En3V0P8cmvvt/1Wgh78=</diagram></mxfile>",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 30 12.85 L 0 12.85",
    fill: "none",
    stroke: "#666666",
    strokeMiterlimit: 10,
    pointerEvents: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -1,
    y: 7.85,
    width: 20,
    height: 10,
    rx: 1.5,
    ry: 1.5,
    fill: "#4d4d4d",
    stroke: "none",
    transform: "rotate(90,9,12.85)",
    pointerEvents: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8.15,
    y: 7.85,
    width: 25,
    height: 10,
    rx: 1.5,
    ry: 1.5,
    fill: "#4d4d4d",
    stroke: "none",
    transform: "rotate(90,20.65,12.85)",
    pointerEvents: "none"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlignVer);
export default __webpack_public_path__ + "static/media/align-ver.b969b677d3603795d5ab25148be14256.svg";
export { ForwardRef as ReactComponent };